import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";

function AddExpense() {

  const navigate = useNavigate();
  const [wallets, setWallets] = useState([]);

  const [form, setForm] = useState({
    wallet_id: "",
    title: "",
    amount: "",
    expense_date: new Date().toISOString().split("T")[0],
    note: ""
  });

  useEffect(() => {
    loadWallets();
  }, []);

  const loadWallets = async () => {

    const res = await API.get("/wallets");

    setWallets(res.data.wallets);

  };

  const submit = async (e) => {

    e.preventDefault();

    try {

      await API.post(
        "/expenses",
        form
      );

      navigate(
        "/admin/expenses"
      );

    } catch (err) {
      console.log(err);
    }

  };

  return (
    <div>

      <h1
        className="
        text-4xl
        font-bold
        mb-6
      "
      >
        Add Expense
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-6
        max-w-3xl
      "
      >

        <div className="mb-5">

          <label className="block mb-2 font-semibold">
            Wallet
          </label>

          <select
            value={form.wallet_id}
            onChange={(e) =>
              setForm({
                ...form,
                wallet_id: e.target.value
              })
            }
            className="
w-full
p-3
rounded-xl
bg-black
border
border-yellow-500/20
"
            required
          >

            <option value="">
              Select Wallet
            </option>

            {
              wallets.map(wallet => (

                <option
                  key={wallet.id}
                  value={wallet.id}
                >
                  {wallet.wallet_name}
                  (
                  ₹{Number(wallet.balance).toFixed(2)}
                  )
                </option>

              ))
            }

          </select>

        </div>

        <div className="mb-5">

          <label
            className="
            block
            mb-2
            font-semibold
          "
          >
            Expense Title
          </label>

          <input
            type="text"
            required
            value={form.title}
            onChange={(e) =>
              setForm({
                ...form,
                title:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
          "
            placeholder="Office Rent"
          />

        </div>

        <div
          className="
          grid
          md:grid-cols-2
          gap-5
          mb-5
        "
        >

          <div>

            <label
              className="
              block
              mb-2
              font-semibold
            "
            >
              Amount
            </label>

            <input
              type="number"
              required
              value={form.amount}
              onChange={(e) =>
                setForm({
                  ...form,
                  amount:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
            "
              placeholder="15000"
            />

          </div>

          <div>

            <label
              className="
              block
              mb-2
              font-semibold
            "
            >
              Expense Date
            </label>

            <input
              type="date"
              required
              value={
                form.expense_date
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  expense_date:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
            "
            />

          </div>

        </div>

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            font-semibold
          "
          >
            Note
          </label>

          <textarea
            rows="5"
            value={form.note}
            onChange={(e) =>
              setForm({
                ...form,
                note:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
          "
            placeholder="Expense details..."
          />

        </div>

        <div
          className="
          flex
          gap-3
        "
        >

          <button
            type="submit"
            className="
            bg-yellow-500
            text-black
            px-6
            py-3
            rounded-xl
            font-semibold
          "
          >
            Save Expense
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/admin/expenses"
              )
            }
            className="
            bg-gray-700
            px-6
            py-3
            rounded-xl
          "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>
  );
}

export default AddExpense;